import { useEffect, useState } from "react"

export const useIsPageScrolling = () => {
  const [isPageScrolling, setIsPageScrolling] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY <= 10) {
        setIsPageScrolling(false)
      } else {
        setIsPageScrolling(true)
      }
    }

    window.addEventListener("scroll", handleScroll)

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return { isPageScrolling }
}
